import api from "./api";

const getByComplaintId = (id) => {
    return api.get(`/admin/status-audits-complaint/${id}`);
}

const getById = (id) => {
    return api.get(`/complaint-statuses/${id}`);
}

const get = ({ complaint_id, id }) => {
    if (complaint_id)
        return getByComplaintId(complaint_id);
    if (id)
        return getById(id);
    console.error('Cannot search by name and id at the same time');
}

export const StatusAuditAPI = {
    get
}